export default () => ({
  serverHost: process.env.NODE_ENV === 'production' ? window.location.host : process.env.REACT_APP_SERVER_HOST,
  zoneId: process.env.REACT_APP_ZONE_ID,
  queueId: process.env.REACT_APP_QUEUE_ID,
  fileServerUrl: window.location.origin,
});
